import theme from '../../../theme';

const styles = {
  button: {
    margin: '10px 0',
    padding: '10px',
    color: theme.palette.grey[800],
  },
};

export default styles;
